const CustomToggleButton = ({
  isDiscountCorporate,
  setIsDiscountCorporate,
}) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        marginBottom: "20px",
        alignItems: "center",
        width: "100%", // Ensure the container takes full width
      }}
    >
      <div
        style={{
          display: "flex",
          border: "1px solid #009B94", // Updated border color to match the background
          borderRadius: "20px",
          overflow: "hidden",
          width: "100%", // Full width of the parent container
          maxWidth: "400px", // Optional: cap the width for larger screens
          height: "45px", // Slightly taller for better appearance
          position: "relative",
          background: "white",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", // Subtle shadow for depth
        }}
      >
        {/* Sliding background */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: isDiscountCorporate ? "50%" : "0",
            width: "50%", // Half the width for the sliding effect
            height: "100%",
            background: "#009B94", // Updated background color
            transition: "left 0.3s ease",
            zIndex: 0,
            borderRadius: "20px", // Match the parent border radius
          }}
        />
        <button
          style={{
            flex: 1,
            border: "none",
            background: "transparent",
            color: isDiscountCorporate ? "#333" : "white",
            fontSize: "16px",
            fontWeight: "600", // Bolder text
            cursor: "pointer",
            zIndex: 1,
            position: "relative",
            padding: "10px", // Add padding for better spacing
            transition: "color 0.3s ease",
          }}
          onClick={() => setIsDiscountCorporate(false)}
          onMouseEnter={
            (e) =>
              (e.target.style.color = isDiscountCorporate ? "#009B94" : "white") // Updated hover color
          }
          onMouseLeave={(e) =>
            (e.target.style.color = isDiscountCorporate ? "#333" : "white")
          }
        >
          Corporate
        </button>
        <button
          style={{
            flex: 1,
            border: "none",
            background: "transparent",
            color: isDiscountCorporate ? "white" : "#333",
            fontSize: "16px",
            fontWeight: "600",
            cursor: "pointer",
            zIndex: 1,
            position: "relative",
            padding: "10px",
            transition: "color 0.3s ease",
          }}
          onClick={() => setIsDiscountCorporate(true)}
          onMouseEnter={
            (e) =>
              (e.target.style.color = isDiscountCorporate ? "white" : "#009B94") // Updated hover color
          }
          onMouseLeave={(e) =>
            (e.target.style.color = isDiscountCorporate ? "white" : "#333")
          }
        >
          Discount Corporate
        </button>
      </div>
    </div>
  );
};
export default CustomToggleButton;
